import type { Translate } from 'next-translate'

import { StyleLimits } from '@/src/domains/recommended-therapist/constants'

export const getStyleMatchTitle = (styleMatch: number, t: Translate) => {
  if (styleMatch >= StyleLimits.GREAT) {
    return t(`component.recommendedTherapist.style.great.title`)
  } else if (styleMatch >= StyleLimits.GOOD) {
    return t(`component.recommendedTherapist.style.good.title`)
  } else if (styleMatch >= StyleLimits.OK) {
    return t(`component.recommendedTherapist.style.ok.title`)
  } else {
    return t(`component.recommendedTherapist.style.poor.title`)
  }
}

export const getStyleMatchLabel = (styleMatch: number, t: Translate) => {
  if (styleMatch >= StyleLimits.GREAT) {
    return t(`component.recommendedTherapist.style.great.label`)
  } else if (styleMatch >= StyleLimits.GOOD) {
    return t(`component.recommendedTherapist.style.good.label`)
  } else if (styleMatch >= StyleLimits.OK) {
    return t(`component.recommendedTherapist.style.ok.label`)
  } else {
    return t(`component.recommendedTherapist.style.poor.label`)
  }
}
